import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    gotGuestDetailsResponse: false,
    guestDetailsList: [],
    currentGuestDetails: {}
};

const guestDetailsSlice = createSlice({
    name: 'guestDetails',
    initialState,
    reducers: {
        resetGuestDetails: () => initialState,
        setGotGuestDetailsResponse: (state, action) => {
            state.gotGuestDetailsResponse = action.payload;
        },
        setGuestDetailsList: (state, action) => {
            state.guestDetailsList = action.payload
        },
        setCurrentGuestDetails: (state, action) => {
            state.currentGuestDetails = action.payload
        }
    },
});

export const { resetGuestDetails, setGotGuestDetailsResponse, setGuestDetailsList, setCurrentGuestDetails } = guestDetailsSlice.actions;

export default guestDetailsSlice.reducer;
